import CalendarPage from "../../components/ClassOne/Mathematics/ChooseCalender";
import DaysOfWeek from "../../components/ClassOne/Mathematics/DaysOfWeek";
import FillBlankCalender from "../../components/ClassOne/Mathematics/FillBlankCalender";
import MonthOfYear from "../../components/ClassOne/Mathematics/MonthOfYear";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/calender/days-of-the-week", title: "Days of the Week", component: DaysOfWeek },
    { url: "/class-one/mathematics/calender/months-of-the-year", title: "Months of the Year", component: MonthOfYear },
    { url: "/class-one/mathematics/calender/choose-correct", title: "Look at Calender", component: CalendarPage },
    { url: "/class-one/mathematics/calender/multiple-choice", title: "Multiple Choice Questions", component: FillBlankCalender },
];

export default topics;